// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"236f818b","71":"7c1d1386","124":"a3d4f172","170":"08a970cd","526":"31d20416","701":"9c2065b6","754":"0411bd05","803":"78c5e548"}[chunkId] + ".chunk.css";
};